// Utility functions for converting values between different units.
// Keeps as number for calculations
export const fromHundredths = (value: number | null | undefined): number => {
  if (value == null) return 0;
  return value / 100;
};

// Formats as string for display
export const formatHundredths = (
  value: number | null | undefined,
  decimals = 2,
): string => {
  if (value == null) return "";

  return (value / 100).toFixed(decimals);
};
